// extracted by mini-css-extract-plugin
export var btn = "button-module--btn--s1DWH";
export var sm = "button-module--sm--wQUYn";
export var md = "button-module--md--ysQPK";
export var primary = "button-module--primary--BaDno";